import { useState } from "react";

export function useStateBoolean(initial: boolean): [boolean, VoidFunction, VoidFunction] {
    const [value, setValue] = useState<boolean>(initial);    
    return [value, () => setValue(true), () => setValue(false)]
}